import { render, staticRenderFns } from "./extractIngDetail.vue?vue&type=template&id=19314240&scoped=true"
import script from "./extractIngDetail.vue?vue&type=script&lang=js"
export * from "./extractIngDetail.vue?vue&type=script&lang=js"
import style0 from "./extractIngDetail.vue?vue&type=style&index=0&id=19314240&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19314240",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19314240')) {
      api.createRecord('19314240', component.options)
    } else {
      api.reload('19314240', component.options)
    }
    module.hot.accept("./extractIngDetail.vue?vue&type=template&id=19314240&scoped=true", function () {
      api.rerender('19314240', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/doubleRandom/projectExtract/extractIngDetail.vue"
export default component.exports